module.exports = __webpack_public_path__ + "static/media/3.ccca7777.JPG";